import { render, staticRenderFns } from "./PerksModal.vue?vue&type=template&id=aeaf52c8&"
import script from "./PerksModal.vue?vue&type=script&lang=js&"
export * from "./PerksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports